import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCANzydgDS-nZBZ6bgzmRPdxZGVXRr6tgg",
  authDomain: "mymedical-1.firebaseapp.com",
  projectId: "mymedical-1",
  storageBucket: "mymedical-1.firebasestorage.app",
  messagingSenderId: "767338585690",
  appId: "1:767338585690:web:ad1aef157f80826343c263",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
